import React from 'react';
import { BookOpenIcon, BrainIcon, VideoIcon, GraduationCapIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Banner fino de oferta - atraviesa toda la página */}
      <div className="w-full bg-white py-1.5 px-4 border-t border-b border-[#c41e3a] overflow-hidden" data-id="element-97">
        <div className="animate-scroll-right" data-id="element-98">
          <p className="text-black text-xs md:text-sm font-bold tracking-wide whitespace-nowrap" data-id="element-99">
            💈 OFERTA POR LANZAMIENTO - 60% DE DESCUENTO 💈 OFERTA POR
            LANZAMIENTO - 60% DE DESCUENTO 💈 OFERTA POR LANZAMIENTO - 60% DE
            DESCUENTO
          </p>
        </div>
      </div>

      <section className="w-full bg-[#0a0a0a] py-16 md:py-20 lg:py-24 px-4 relative" data-id="element-100">
        {/* Logo flotante - Barber Pro Academy */}
        <div className="fixed top-6 left-6 z-50" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/nTBDp8jLQqs428HDhKddZJ/ChatGPT_Image_24_feb_2026,_12_38_15_a.m..png" alt="Barber Pro Academy Logo" className="w-16 h-16 md:w-20 md:h-20 drop-shadow-2xl" data-id="element-102" />
        </div>

        <div className="max-w-7xl mx-auto" data-id="element-103">
          <div className="text-center mb-20" data-id="element-104">
            {/* Pre-headline */}
            <p className="text-lg md:text-xl text-gray-400 mb-6 font-semibold" data-id="element-105">
              Para quienes quieren aprender barbería en serio, no solo mirar
              videos sueltos
            </p>

            {/* Título principal H1 */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-tight text-white mb-8" data-id="element-106">
              Formación profesional en barbería con un método claro, aplicable y
              real
            </h1>

            {/* Línea decorativa */}
            <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-8" data-id="element-107"></div>

            {/* Subtítulo H2 */}
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-4xl mx-auto mb-10" data-id="element-108">
              Aprendé barbería con criterio profesional a través de una
              formación en{' '}
              <span className="text-white font-bold" data-id="element-109">ebook + videos</span>,
              pensada para que sepas qué hacer, por qué hacerlo y cómo aplicarlo
              en cortes reales, desde el primer día.
            </p>

            {/* Bullets de escaneo */}
            <div className="max-w-3xl mx-auto mb-12 space-y-3" data-id="element-110">
              <div className="flex items-center justify-center gap-3 text-gray-200" data-id="element-111">
                <CheckIcon className="w-6 h-6 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-112" />
                <span className="text-lg md:text-xl font-semibold" data-id="element-113">
                  Método profesional, no trucos aislados
                </span>
              </div>
              <div className="flex items-center justify-center gap-3 text-gray-200" data-id="element-114">
                <CheckIcon className="w-6 h-6 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-115" />
                <span className="text-lg md:text-xl font-semibold" data-id="element-116">
                  Aplicable en barbería real y trabajo independiente
                </span>
              </div>
              <div className="flex items-center justify-center gap-3 text-gray-200" data-id="element-117">
                <CheckIcon className="w-6 h-6 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-118" />
                <span className="text-lg md:text-xl font-semibold" data-id="element-119">
                  Ideal para principiantes y quienes quieren ordenarse
                </span>
              </div>
              <div className="flex items-center justify-center gap-3 text-gray-200" data-id="element-120">
                <CheckIcon className="w-6 h-6 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-121" />
                <span className="text-lg md:text-xl font-semibold" data-id="element-122">
                  Material de consulta permanente
                </span>
              </div>
            </div>
          </div>

          {/* Imagen principal - más pequeña */}
          <div className="flex justify-center mb-20" data-id="element-123">
            <img src="https://cdn.magicpatterns.com/uploads/xxiNDAdA5WvE8qmHCeXCdE/Gemini_Generated_Image_y45kpy45kpy45kpy.png" alt="Método Barber Pro - Formación profesional en barbería" className="w-full max-w-sm md:max-w-md rounded-lg shadow-2xl" data-id="element-124" />
          </div>

          {/* Bullets en cards grandes y rectangulares */}
          <div className="max-w-5xl mx-auto mb-16" data-id="element-125">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-126">
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-127">
                <BookOpenIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-128" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-129">
                  Ebooks profesionales descargables
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-130">
                <BrainIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-131" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-132">
                  Método estructurado, no improvisación
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-133">
                <VideoIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-134" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-135">
                  Videos de apoyo incluidos
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-136">
                <GraduationCapIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-137" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-138">
                  Enfoque técnico y profesional
                </span>
              </div>
            </div>
          </div>

          {/* CTA más grande - ahora con scroll a precios */}
          <div className="flex flex-col items-center gap-3" data-id="element-139">
            <a href="#pricing" className="bg-[#c41e3a] hover:bg-[#a01830] text-white font-black text-2xl px-16 py-7 rounded-lg transition-colors duration-200 shadow-2xl inline-block text-center" aria-label="Acceder al Método Barber Pro" data-id="element-140">
              👉 Accedé al Método Barber Pro
            </a>
            <p className="text-gray-400 text-sm md:text-base font-semibold" data-id="element-141">
              Acceso inmediato · 100% online
            </p>
          </div>
        </div>
      </section>
    </>;
}